import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import APP_CONSTANTS from '../../config/constants';
import Axios from 'axios';
import $ from 'jquery'
import ReadAxios from '../axiosComponent/read';
const MyToLocation = ({
    field: { name, value },
    form: { touched, errors, setFieldValue },
    ...props
}) => {
    const errorText = touched[name] && errors[name];
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        // $("#searchType .dropdown").removeClass("dropdown")
    }, [])
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            ReadAxios({ url: 'routeManagerConsignee/', readItems: { searchTerm: searchTerm } })
                .then((result) => {
                    setcontent(result)
                    setloading(false)
                })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.checkPointId
            temp.text = `${object.checkPointCode}(${object.checkPointName})`
            temp.value = { code: object.checkPointCode, text: object.checkPointName, id: object.checkPointId }
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyToLocation